import React, { useState } from "react";
import { Box, Container, Tabs, Tab, Paper, Typography } from "@mui/material";
import { DepartmentStockList } from "../../components/DepartmentStock/DepartmentStockList";
import { StockLevelManager } from "../../components/DepartmentStock/StockLevelManager";

export const InvDepartmentStockPage = () => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Box  
      sx={{
        minHeight:'100vh',
        background: 'linear-gradient(180deg, #f9fafc 0%, #f2f5f8 100%)',
      }}
    >
    <Container maxWidth="xl" sx={{ py: 2 }}>
      <Box sx={{ py: 4 }}>
        {/* Header Section */}
        <Box sx={{ mb: 4, textAlign: "center" }}>
          <Typography 
            variant="h3" 
            component="h1" 
            sx={{ 
              fontWeight: 700,
              color: "primary.main",
              mb: 1,
              fontSize: { xs: '2rem', md: '2.5rem', lg: '3rem' }
            }}
          >
            Department Stock Management
          </Typography>
          <Typography 
            variant="h6" 
            sx={{ 
              color: "text.secondary",
              fontSize: { xs: '1rem', md: '1.2rem' },
              maxWidth: '600px',
              mx: 'auto'
            }}
          >
            Manage and monitor stock levels across all departments
          </Typography>
        </Box>

        {/* Tabs Section */}
        <Paper 
          elevation={3} 
          sx={{ 
            mb: 4, 
            borderRadius: 3,
            overflow: 'hidden'
          }}
        >
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
            sx={{
              '& .MuiTab-root': {
                fontSize: { xs: '0.9rem', sm: '1rem', md: '1.1rem' },
                fontWeight: 600,
                py: 3,
                minHeight: 'auto',
                transition: 'all 0.3s ease',
                '&:hover': {
                  backgroundColor: 'action.hover',
                }
              },
              '& .MuiTabs-indicator': {
                height: 4,
                borderRadius: 2
              }
            }}
          >
            <Tab 
              label={
                <Box sx={{ textAlign: 'center' }}>
                  <Typography variant="body1" sx={{ fontWeight: 600, fontSize: 'inherit' }}>
                    Department Stock Overview
                  </Typography>
                  <Typography variant="caption" sx={{ display: { xs: 'none', sm: 'block' }, mt: 0.5 }}>
                    View all department stocks
                  </Typography>
                </Box>
              } 
            />
            <Tab 
              label={
                <Box sx={{ textAlign: 'center' }}>
                  <Typography variant="body1" sx={{ fontWeight: 600, fontSize: 'inherit' }}>
                    Stock Level Manager
                  </Typography>
                  <Typography variant="caption" sx={{ display: { xs: 'none', sm: 'block' }, mt: 0.5 }}>
                    Manage stock levels
                  </Typography>
                </Box>
              } 
            />
          </Tabs>
        </Paper>

        {/* Content Section */}
        <Paper 
          elevation={2} 
          sx={{ 
            borderRadius: 3,
            p: { xs: 2, sm: 3, md: 4 },
            minHeight: '500px',
            backgroundColor: 'background.default'
          }}
        >
          <Box sx={{ mt: 2 }}>
            {activeTab === 0 && <DepartmentStockList />}
            {activeTab === 1 && <StockLevelManager />}
          </Box>
        </Paper>
      </Box>
    </Container>
    </Box>
  );
};